import type { ResourceType, RoleWithResource } from 'types/models';

export const roleToCustomerIoIdentifier = (role: RoleWithResource): string =>
  `${role.resource_type}_${role.resource_id}`;

export const getOrganizationRoleResourceTypeKey = (resourceType: ResourceType) =>
  `${resourceType.toLocaleLowerCase()}OrgId`;
